import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../shared.service';

@Component({
  selector: 'app-conformation-dailog',
  templateUrl: './conformation-dialog.component.html',
  styleUrls: ['./conformation-dialog.component.scss']
})
export class ConformationDialogComponent implements OnInit {
  extraButton: { name: '', isVisible: false, }

  constructor(
    public dialogRef: MatDialogRef<ConformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sharedService: SharedService,
  ) { }

  ngOnInit() {
    if (this.data && this.data.extraButton) {
      this.extraButton = this.data.extraButton;
    }
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  conformOk(): void {
    this.dialogRef.close(true);
  }

  extraButtonClick(): void {
    this.dialogRef.close('extraButtonClick');
  }

}
